/**
 * M-ily Glow Up — Boucle infinie carrousel produit
 * Diagnostic confirmé : sw.select=function, slides=4, infinite=true
 * Problème : disabled=false bloque le select() sur desktop
 * Solution : écouter touchstart/touchend sur slideshow-slides directement
 * et appeler select() en contournant le check disabled
 */
(function () {
  'use strict';

  function initSlideshow(sw) {
    if (sw._milyDone) return;
    sw._milyDone = true;

    // Le scroller est l'élément slideshow-slides
    var scroller = sw.querySelector('slideshow-slides');
    if (!scroller) return;

    var touchStartX = 0;
    var touchStartY = 0;

    scroller.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    scroller.addEventListener('touchend', function (e) {
      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var dx = touchStartX - endX;
      var dy = touchStartY - endY;

      if (Math.abs(dy) > Math.abs(dx)) return;
      if (Math.abs(dx) < 40) return;

      var slides = Array.prototype.slice.call(
        sw.querySelectorAll('slideshow-slide:not([hidden])')
      );
      if (slides.length < 2) return;

      var lastIndex = slides.length - 1;
      var current = typeof sw.current === 'number' ? sw.current : 0;
      var swipingLeft = dx > 0;

      // On ne boucle qu'aux extrémités
      if (swipingLeft && current === lastIndex) {
        // Dernière photo -> première
        // Contourner disabled temporairement
        var wasDisabled = sw.getAttribute('disabled');
        sw.setAttribute('disabled', 'false');
        sw.removeAttribute('disabled');
        sw.select(0, null, { animate: true });
        if (wasDisabled !== null) sw.setAttribute('disabled', wasDisabled);

      } else if (!swipingLeft && current === 0) {
        // Première photo -> dernière
        var wasDisabled2 = sw.getAttribute('disabled');
        sw.setAttribute('disabled', 'false');
        sw.removeAttribute('disabled');
        sw.select(lastIndex, null, { animate: true });
        if (wasDisabled2 !== null) sw.setAttribute('disabled', wasDisabled2);
      }
    }, { passive: true });
  }

  function setup() {
    document.querySelectorAll('media-gallery slideshow-component').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
      setTimeout(setup, 800);
    });
  } else {
    setup();
    setTimeout(setup, 800);
  }

  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('variant:changed', function () { setTimeout(setup, 400); });

}());
